import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CusEntInfoLineNumberPopup from './cusEnt-info-linenumber-popup';
import CusEntInfoStore from '../corp-info/corp-info-store';

const CusEntInfoLineNumberPopupContainer = () => {
  // console.log('CardBillAccountInfoPopupContainer Load');

  const { visibleLineNumberPopup, lineNumberList } = CusEntInfoStore;
  const [ textBoxValue, setTextBoxValue] = useState('');
  const [ copyLineNumberList, setCopyLineNumberList] = useState([]);
  const [notifyMsg, setNotifyMsg] = useState();

  useEffect(() => {
    // console.log('CardBillAccountInfoPopupContainer > useEffect()');
    
    if (visibleLineNumberPopup) {

    } 
    CusEntInfoStore.getCusEntLineNumber();
    setCopyLineNumberList(lineNumberList)
  }, [ visibleLineNumberPopup ]);

  const calculatePopupSize = () => {
    // 리스트 아이템 개수에 따라 팝업창 크기를 계산하는 로직 추가
    const itemCount = copyLineNumberList.length;
    // 팝업 크기 계산 로직 추가 (예: 기본 크기에 아이템 개수를 곱하거나 원하는 방식으로 계산)
    const popupHeight = 250 + itemCount * 35.7;
    return { height: popupHeight };
  };

  // const onSelectionChangedList = useCallback((e) => {
  //   if (e.addedItems.length > 0) {
  //       setTextBoxValue(e.addedItems[0].LineNumber);
  //   } else {
  //       setTextBoxValue('');
  //   }
  // });

  const onValueChangedTextBox = useCallback((e) => {
    setTextBoxValue(e.value);
  });

  const onClickInsert = () => {
    if (textBoxValue.length > 0) {
      // 텍스트박스의 값이 리스트에 추가되도록 로직 작성
      const addLineNumber = { LineNumber: textBoxValue }

      const lineNumber = copyLineNumberList.map((data) => data.LineNumber).join(',');
      const isValidLineNumber = lineNumber.includes(textBoxValue)
      if (!isValidLineNumber) {
        setCopyLineNumberList([...copyLineNumberList, addLineNumber]);
        setNotifyMsg('');
      } else {
        setNotifyMsg('중복되거나 허용되지 않는 번호가 있습니다.');
      }
      // 텍스트박스 비우기
      setTextBoxValue('');
    } else {
      setNotifyMsg('전화번호를 입력해주시기 바랍니다.');
      setTextBoxValue('');
    }
  };

  const onClickDelete = () => {
    // 텍스트박스의 값이 리스트에서 제거되도록 로직 작성
    // const deleteLineNumber = { LineNumber: textBoxValue }
    // const updatedList = copyLineNumberList.filter(item => item !== deleteLineNumber);
    // setCopyLineNumberList(updatedList);
    // console.log(copyLineNumberList)
    // 텍스트박스 비우기
    // setTextBoxValue('');    
  };

  const onClickSave = useCallback(async () => {
    const lineNumber = copyLineNumberList.map((data) => data.LineNumber).join(',');
    
    if (copyLineNumberList.length == 0) {
      setNotifyMsg('저장할 전화번호가 없습니다.');
    } else if (window.confirm("저장하시겠습니까?")) {
      const result = await CusEntInfoStore.updateCusEntLineNumber(
        lineNumber,
      );
        
      if (result.error) {
        setNotifyMsg(result.message);
      } else {
        alert(result.message);
        CusEntInfoStore.setVisibleLineNumberPopup(false);
        setNotifyMsg('');
      }
    }
  }, [copyLineNumberList]);

  if (!copyLineNumberList) {
    return;
  }

  return (
    <CusEntInfoLineNumberPopup
      onHiding={() => CusEntInfoStore.setVisibleLineNumberPopup(false)}
      onClickInsert={onClickInsert}
      onClickDelete={onClickDelete}
      onClickSave={onClickSave}
      visibleLineNumberPopup={visibleLineNumberPopup}
      lineNumberList={copyLineNumberList}
      textBoxValue={textBoxValue}
      onValueChangedTextBox={onValueChangedTextBox}
      notifyMsg={notifyMsg}
      // onSelectionChangedList={onSelectionChangedList}
      calculatePopupSize={calculatePopupSize}
    />
  );
};

export default React.memo(observer(CusEntInfoLineNumberPopupContainer));